// Vue 3 正确写法
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import vue3SeamlessScroll from "vue3-seamless-scroll";
import { lazyLoadDirective } from '@/utils/lazyLoadDirective '
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.directive('lazyload', lazyLoadDirective)
app.use(vue3SeamlessScroll);
app.use(router)
app.use(ElementPlus)
app.mount('#app')

